import Vue from 'vue'
import Vuex from "vuex";
import router from "../router";
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: {
      username: '',
      first_name: '',
      last_name: '',
      email: '',
      company: ''
    },
    loggedInStatus: false,
    roles: {},
    salesChannels: [
      {id: 1, name: 'schuhe.de', img: 'schuhede-parent.svg'},
      {id: 2, name: 'eBay', img: 'schuhede-ebay.svg'},
      {id: 3, name: 'Zalando', img: 'schuhede-zalando.svg'},
      {id: 4, name: 'Amazon', img: 'schuhede-amazon.svg'},
      {id: 5, name: 'eBay', img: 'ebay.svg'},
      {id: 6, name: 'Zalando', img: 'zalando.svg'},
      {id: 7, name: 'Amazon', img: 'amazon.svg'},
      {id: 8, name: 'schuhe.de - Parent', img: 'schuhede-parent.svg'},
      {id: 9, name: 'Spartoo', img: 'spartoo.svg'},
      {id: 10, name: 'Spartoo', img: 'schuhede-spartoo.svg'},
      {id: 11, name: 'Mirapodo', img: 'mirapodo.svg'},
      {id: 12, name: 'Mirapodo', img: 'schuhede-mirapodo.svg'},
      {id: 13, name: 'Warentrade', img: 'warentrade.svg'},
      {id: 14, name: 'Warentrade - Amazon', img: 'warentrade.svg'},
      {id: 15, name: 'Warentrade - eBay', img: 'warentrade.svg'},
      {id: 16, name: 'Warentrade - Spartoo', img: 'warentrade.svg'},
      {id: 17, name: 'Tamaris', img: 'tamaris.svg'},
      {id: 18, name: 'Tamaris', img: 'schuhede-tamaris.svg'},
      {id: 19, name: 'Check24', img: 'check24.svg'},
      {id: 20, name: 'Check24', img: 'schuhede-check24.svg'}
    ],
    filterChannels: [
      {id: 1, name: 'schuhe.de', img: 'schuhede-parent.svg', icon: 'fa-schuhe'},
      {id: 2, name: 'eBay', img: 'schuhede-ebay.svg', icon: 'fa-ebay'},
      {id: 3, name: 'Zalando', img: 'schuhede-zalando.svg', icon: 'fa-zalando'},
      {id: 4, name: 'Amazon', img: 'schuhede-amazon.svg', icon: 'fa-amazon'},
      {id: 10, name: 'Spartoo', img: 'schuhede-spartoo.svg', icon: 'fa-spartoo'},
      {id: 12, name: 'Mirapodo', img: 'schuhede-mirapodo.svg', icon: 'fa-mirapodo'},
      {id: 18, name: 'Tamaris', img: 'schuhede-tamaris.svg', icon: 'fa-tamaris'},
      {id: 20, name: 'Check24', img: 'schuhede-check24.svg', icon: 'fa-check-24'}
    ],
    language: 'de',
    stores: [],
    alerts: [],
    token: '',
    parcelOptions: [],
    companies: [],
    orderStatusFilters: [],
    orderPaymentsFilters: [],
    orderChannelsFilters: [],
    companyErpNameHelper: '',
    companyErpIdHelper: '',
    version: '1.0',
    env: getEnv()
  },
  getters: {
    user: state => {
      return state.user
    },
    alerts: state => {
      return state.alerts
    },
    orderStatusFilters: state => {
      return state.orderStatusFilters
    },
    orderPaymentsFilters: state => {
      return state.orderPaymentsFilters
    },
    orderChannelsFilters: state => {
      return state.orderChannelsFilters
    },
    companies: state => {
      return state.companies
    },
    language: state => {
      return state.language
    },
    stores: state => {
      return state.stores
    },
    roles: state => {
      return state.roles
    },
    parcelOptions: state => {
      return state.parcelOptions
    },
    token: state => {
      return state.token
    },
    loggedInStatus: state => {
      return state.loggedInStatus
    },
    env: state => {
      return state.env
    },
    version: state => {
      return state.version
    },
    companyErpNameHelper: state => {
      return state.companyErpNameHelper
    },
    companyErpIdHelper: state => {
      return state.companyErpIdHelper
    },
    salesChannels: state => {
      return state.salesChannels
    },
    filterChannels: state => {
      return state.filterChannels
    },
    salesChannelById: state => (id) => {
      return state.salesChannels.find(channel => channel.id === parseInt(id))
    }
  },
  mutations: {
    initialiseStore (state) {
      let savedStore = localStorage.getItem ('store')
      if(savedStore) {
        if (JSON.parse(savedStore).version === state.version) {
          this.replaceState(
            Object.assign(state, JSON.parse(localStorage.getItem('store')))
          )
        }
      }
    },
    updateUser (state, user) {
      if (typeof state.user === 'string') {
        state.user = JSON.parse(state.user)
      }
      for (let x in user) {
        state.user[x] = user[x]
      }
    },
    pushAlert (state, alert) {
      state.alerts.push(alert)
    },
    removeAlert (state, alert) {
      state.alerts.splice(state.alerts.indexOf(alert))
    },
    updateOrderStatusFilters (state, data) {
      state.orderStatusFilters = data
    },
    updateOrderPaymentsFilters (state, data) {
      if (data.length > 0) {
        state.orderPaymentsFilters = data
      }
      state.orderPaymentsFilters.unshift('all')
    },
    updateOrderChannelsFilters (state, data) {
      if (data.length > 0) {
        state.orderChannelsFilters = data
      }
      state.orderChannelsFilters.unshift('all')
    },
    updateCompanies (state, companies) {
      state.companies = companies
    },
    updateRoles (state, roles) {
      state.roles = roles
    },
    updateParcelOptions (state, data) {
      state.parcelOptions = data
    },
    updateToken (state, token) {
      state.token = token
    },
    updateLanguage (state, lang) {
      state.language = lang
    },
    updateLoggedInStatus (state, data) {
      state.loggedInStatus = data
    },
    updateCompanyErpNameHelper (state, data) {
      state.companyErpNameHelper = data
    },
    updateCompanyErpIdHelper (state, data) {
      state.companyErpIdHelper = data
    }
  },
  actions: {
    logout (context) {
      API.get('/logout')
        .then(response => {
          store.commit('updateLoggedInStatus', false)
          API.defaults.headers.common['auth-token'] = ''
          window.localStorage.clear()
          router.push('/')
        })
    },
    checkPermissions (context, type) {
      let roles = store.getters.roles
      if (roles === null) {
        console.log('NOT AUTHORIZED')
        router.push('/')
        return false
      }
      return type === 'admin' ? true : roles[type]
    },
    checkError (context, error) {
      if (error.status === 403) {
        store.commit('pushAlert', {type: 'danger', dismiss: 4, message: `Error Code: 403 - Forbidden`, icon: 'icon fa fa-ban'})
        return false
      } else if (error.status === 401) {
        store.dispatch('logout')
      } else return true
    }
  }
})
export default store
function getEnv () {
  let productionURLs = ['cs.qb-schuhe.de', 'qb-schuhe.de', 'qualibet-schuhe.de', 'qbschuhe.de', 'www.qb-schuhe.de', 'www.qualibet-schuhe.de', 'www.qbschuhe.de', 'myplace.schuhe.de']
  if ((productionURLs.indexOf(window.location.hostname)) !== -1) {
    return 'live'
  } else if (window.location.hostname === 'localhost' || window.location.hostname === 'qualibet.local') {
    return 'dev'
  } else if (window.location.hostname === 'cs.staging-qb.de') {
    return 'staging'
  }
}



// WEBPACK FOOTER //
// ./src/store/index.js